export class UserCredentialsModel {
  email: string;
  pass: string;
}
